"use strict";

var _slicedToArray = require("/home/runner/work/leny.github.io/leny.github.io/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require("@pwops/core"),
    registerMixin = _require.registerMixin;

var fromEntries = require("lodash.frompairs");

var position = function position(type) {
  return function () {
    var entries = {};

    switch (arguments.length) {
      case 0:
        return {
          position: type
        };

      case 1:
        entries = {
          position: type,
          top: arguments.length <= 0 ? undefined : arguments[0],
          right: arguments.length <= 0 ? undefined : arguments[0],
          bottom: arguments.length <= 0 ? undefined : arguments[0],
          left: arguments.length <= 0 ? undefined : arguments[0]
        };
        break;

      case 2:
        entries = {
          position: type,
          top: arguments.length <= 0 ? undefined : arguments[0],
          right: arguments.length <= 1 ? undefined : arguments[1],
          bottom: arguments.length <= 0 ? undefined : arguments[0],
          left: arguments.length <= 1 ? undefined : arguments[1]
        };
        break;

      case 3:
        entries = {
          position: type,
          top: arguments.length <= 0 ? undefined : arguments[0],
          right: arguments.length <= 1 ? undefined : arguments[1],
          bottom: arguments.length <= 2 ? undefined : arguments[2],
          left: arguments.length <= 1 ? undefined : arguments[1]
        };
        break;

      case 4:
        entries = {
          position: type,
          top: arguments.length <= 0 ? undefined : arguments[0],
          right: arguments.length <= 1 ? undefined : arguments[1],
          bottom: arguments.length <= 2 ? undefined : arguments[2],
          left: arguments.length <= 3 ? undefined : arguments[3]
        };
        break;

      default:
        throw new TypeError("Invalid argument amount for ".concat(type));
    }

    return fromEntries(Object.entries(entries).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          val = _ref2[1];

      return val != null && val !== false;
    }));
  };
};

registerMixin("static", position("static"));
registerMixin("relative", position("relative"));
registerMixin("absolute", position("absolute"));
registerMixin("sticky", position("sticky"));
registerMixin("fixed", position("fixed"));